import hcAxios, { RequestOptions } from 'core/utils/hcAxios'
import { TResponse } from 'core/service/hcResponse'
// hotcoin优化相关接口
enum API {
  /** 用户退出登录 @Frank */
  UserLogout = '/hk-web/v2/logout',
}

export type TPostUserLogoutParams = any
export type TPostUserLogoutResponse = TResponse<{}>

export const postUserLogout = (params?: TPostUserLogoutParams, options?: RequestOptions) => {
  return hcAxios.post<TPostUserLogoutResponse>(API.UserLogout, params, { options })
}

enum API {
  /** 三项安全验证 @admin */
  ModifySafetyCheck = '/hk-web/modifySafetyCheck',
}

export type TPostModifySafetyCheckParams = {
  emailValidCode?: string
  googleValidCode?: string
  smsValidCode?: string
  businessType?: string
}

export type TPostModifySafetyCheckResponse = TResponse<any>
export const postModifySafetyCheck = (params?: TPostModifySafetyCheckParams, options?: RequestOptions) => {
  return hcAxios.post<TPostModifySafetyCheckResponse>(API.ModifySafetyCheck, params, { options })
}
